import React from "react";
import {
  TextField,
  CircularProgress,
  Alert,
  Box,
  Autocomplete,
} from "@mui/material";
import { useRegions } from "../hooks";
import type { Region } from "../api/types";

interface RegionSelectProps {
  value: string[];
  onChange: (values: string[]) => void;
  label?: string;
}

export const RegionSelect: React.FC<RegionSelectProps> = ({
  value,
  onChange,
  label = "Select Regions",
}) => {
  const { data, isLoading, error } = useRegions();

  if (error) {
    return (
      <Alert severity="error">
        Failed to load regions. Please try again.
      </Alert>
    );
  }

  const options = data?.data || [];
  const selectedRegions = options.filter((r) => value.includes(r.id));

  const handleChange = (_event: unknown, newValue: Region[]) => {
    onChange(newValue.map((r) => r.id));
  };

  return (
    <Box>
      <Autocomplete
        multiple
        fullWidth
        options={options}
        value={selectedRegions}
        onChange={handleChange}
        getOptionLabel={(option) => option.name}
        loading={isLoading}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder="Search regions..."
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
      />
    </Box>
  );
};
